import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Send, Plus, Mail } from "lucide-react";
import { api } from "@/lib/api";
import { PageHeader, StatusChip, Empty, fmtDate } from "@/components/common";

export default function Campaigns() {
  const [items, setItems] = useState([]);
  const [single, setSingle] = useState([]);
  useEffect(() => {
    api.get("/campaigns").then((r) => setItems(r.data));
    api.get("/messages").then((r) => setSingle(r.data.filter((m) => !m.campaign_id).slice(0, 30)));
  }, []);
  return (
    <div>
      <PageHeader title="Campaigns & send queue" subtitle="Each recipient receives a separate email. Nothing sends without your final confirmation."
        actions={<Link to="/contacts" data-testid="campaign-new-btn" className="cd-btn-primary"><Plus className="h-4 w-4" />Select contacts</Link>} />
      {items.length === 0 ? <Empty icon={Send} title="No campaigns yet" text="Select contacts in the Contacts list or a batch review, then choose “Email selected”." /> : (
        <div className="space-y-2">
          {items.map((c) => (
            <Link key={c.id} to={`/campaigns/${c.id}`} data-testid={`campaign-row-${c.id}`} className="cd-card flex flex-col gap-2 py-3 hover:border-teal-500 sm:flex-row sm:items-center sm:justify-between">
              <div><p className="font-semibold">{c.name}</p><p className="text-xs text-slate-500">{fmtDate(c.created_at)} · {c.mode === "ai" ? "AI personalised" : "Template only"} · {c.message_count} recipient(s)</p></div>
              <div className="flex flex-wrap items-center gap-1"><StatusChip status={c.status} />{Object.entries(c.counts).map(([s, n]) => <span key={s} className="text-xs text-slate-500">{n} {s}</span>)}</div>
            </Link>
          ))}
        </div>
      )}
      <h2 className="mb-3 mt-10 text-lg font-bold">Individual emails</h2>
      <div className="space-y-2">
        {single.length === 0 && <p className="text-sm text-slate-500">None yet.</p>}
        {single.map((m) => (
          <Link key={m.id} to={`/compose?message=${m.id}`} data-testid={`single-message-${m.id}`} className="cd-card flex items-center justify-between gap-2 py-3 hover:border-teal-500">
            <div className="min-w-0"><p className="flex items-center gap-2 truncate font-semibold"><Mail className="h-4 w-4 text-slate-400" />{m.subject || "(generating…)"}</p><p className="truncate text-xs text-slate-500">{m.to_name} · {m.to_email} · {fmtDate(m.sent_at || m.created_at)}</p></div>
            <StatusChip status={m.status} />
          </Link>
        ))}
      </div>
    </div>
  );
}
